/* eslint-disable import/prefer-default-export */

import axios from 'axios';
import { camelizeKeys } from 'humps';

export function getKvEmailTemplates() {
  return axios
    .get('/api/v1/kv/email_templates')
    .then(res => camelizeKeys(res.data.data));
}

export function updateKvTemplate(params) {
  return axios
    .patch(`/api/v1/kv/email_templates/category/${params.category}`, params)
    .then(res => camelizeKeys(res.data));
}

export function createKvTemplate(params) {
  return axios
    .post('/api/v1/kv/email_templates/create', params)
    .then(res => camelizeKeys(res.data));
}

export function changeKvStateTemplate(category) {
  return axios
    .patch(`/api/v1/kv/email_templates/change_state/${category}`)
    .then(res => camelizeKeys(res.data));
}
